import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./conta-listar/conta-listar.module').then(m => m.ContaListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./conta-inserir/conta-inserir.module').then(m => m.ContaInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./conta-editar/conta-editar.module').then(m => m.ContaEditarModule) }


    
    ])],
    exports: [RouterModule]
})
export class ContaAppRoutingModule { }